import { Button, Modal } from 'antd';
import React from 'react';

const ActivationModal = ({
  showModal = false,
  setShowModal,
  title,
  isActive,
  updateStatus,
  mutationId,
  setMutationId,
  name,
  subtitle,
}) => {
  const handleOk = () => {
    updateStatus({
      variables: {
        id: mutationId,
        isActive: !isActive,
      },
    });
  };

  const handleCancel = () => {
    setMutationId('');
    setShowModal(false);
  };
  return (
    <div id="activation-modal-wrapper">
      <Modal
        id="activation-modal"
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2 id="activation-modal-title">{`${title} ${subtitle}`}</h2>
        <p id="activation-confirmation-text">
          Are you sure you want to {title} {name}?
        </p>
        <div className="form-buttons">
          <Button
            id="activation-cancel-btn"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="activation-confirm-btn"
            shape="round"
            type="primary"
            className="save-button"
            onClick={handleOk}
          >
            Yes, {title}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ActivationModal;
